import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from "../../i18n/TranslationProvider";

const VideoPlayer = ({ mediaUid }) => {
  const [ready, setReady] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (ready) return;

    const interval = setInterval(() => {
      const img = new Image();
      img.src = `https://videodelivery.net/${mediaUid}/thumbnails/thumbnail.jpg?time=1s`;
      img.onload = () => {
        setReady(true);
        clearInterval(interval);
      };
    }, 5000);

    return () => clearInterval(interval);
  }, [mediaUid, ready]);

  return (
    <div style={{ marginTop: 8 }}>
      {!ready ? (
        <p style={{ fontSize: 11, color: "#6c757d", padding: "8px 12px", background: "#f8f9fa", borderRadius: 6 }}>
          {t("messages.messagesTable.videoProcessing")}
        </p>
      ) : (
        <iframe
          src={`https://iframe.videodelivery.net/${mediaUid}`}
          style={{ border: "none", width: "100%", height: 200, borderRadius: 6 }}
          allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default VideoPlayer;